import { Card, IconButton, MenuItem, Select, Tooltip } from '@mui/material'
import MDBox from 'components/MDBox'
import React, { useEffect, useState } from 'react'
import DataTable from 'examples/Tables/DataTable'
import DeleteIcon from "@mui/icons-material/Delete";
import CrudService from 'services/cruds-service'
import MDTypography from 'components/MDTypography'
import ContactDeviceAccessTableView from 'cruds/common/contactDeviceAccessTableView'

function ContactDeviceAccess({ selectedContactDeviceAccess, address_item_id, entity_id}) {

    const [selectedThreRows, setSelectedThreRows] = useState([]);
    const [contactsList, setContactsList] = useState([])
    const [contactDeviceAccessList, setContactDeviceAccessList] = useState({})
    const [tempcontactDeviceAccessList, setTempContactDeviceAccessList] = useState([])

    useEffect(() => {
        (async () => {
            try {
                const response = await CrudService.getAllContactsByEntity(entity_id);
                if (response.success) {
                    setContactsList(response.data);
                }
            } catch (err) {
                console.error(err);
                return null;
            }
        })();

        (async () => {
            try {
                const response = await CrudService.getContactDeviceAccessList(address_item_id);
                if (response.success) {
                    let list = response.data.reduce((acc, val) => {
                        acc[val.contact_id] = {access_type: val?.access_type, service_access_type: val?.service_access_type}
                        return acc;
                    }, {})
                    setContactDeviceAccessList(list);
                    // setTempContactDeviceAccessList(response.data)
                    if(response.data.length > 0){
                        setSelectedThreRows(response.data.map((e) => e.contact_id))
                    }
                }
            } catch (err) {
                console.error(err);
                return null;
            }
        })();

    }, [address_item_id, entity_id]);

    useEffect(() => {
        let selectedContacts = contactsList.filter((e) => selectedThreRows.includes(e.contact_id))
        selectedContacts = selectedContacts.map((e, i) => ({
            ...e,
            access_type: contactDeviceAccessList[e.contact_id]?.access_type ?? 'read',
            service_access_type: contactDeviceAccessList[e.contact_id]?.service_access_type ?? 'read',
        }))
        setTempContactDeviceAccessList(selectedContacts)
    }, [selectedThreRows])

    useEffect(() => {
        let processPayload = tempcontactDeviceAccessList.map((val) => ({
            contact_id: val.contact_id,
            address_item_id: address_item_id,
            access_type: val?.access_type,
            service_access_type: val?.service_access_type,
        }))
        selectedContactDeviceAccess.current = processPayload;
    }, [tempcontactDeviceAccessList])

    const removeList = (index) => {
        const updatedContactList = [...tempcontactDeviceAccessList]
        updatedContactList.splice(index, 1)
        setTempContactDeviceAccessList(updatedContactList)
    }
    const handleChange = (index, event) => {
        const { name, value } = event.target;
        const updatedDataTable = [...tempcontactDeviceAccessList];
        updatedDataTable[index].access_type = value;
        setTempContactDeviceAccessList(updatedDataTable);
    };
    const handleServiceChange = (index, event) => {
        const { name, value } = event.target;
        const updatedDataTable = [...tempcontactDeviceAccessList];
        updatedDataTable[index].service_access_type = value;
        setTempContactDeviceAccessList(updatedDataTable);
    };

    const getRows = () => {
        return tempcontactDeviceAccessList.map((row, index) => {
            const fields = [
                {
                    contact_id: row?.contact_id
                },
                {
                    first_name: row?.Contact?.first_name
                },
                {
                    last_name: row?.Contact?.last_name
                },
                {
                    type: row?.Contact?.ContactType?.type_name
                },
            ];

            fields.push(
                {
                    access_type: (
                        <Select label="Access Type" name="access_type" value={row.access_type ?? 'read'} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
                            <MenuItem key={'read'} value={'read'}>Read</MenuItem>
                            <MenuItem key={'write'} value={'write'}>Write</MenuItem>
                        </Select>
                    ),
                    service_access_type: (
                        <Select label="Service Access Type" name="service_access_type" value={row.service_access_type ?? 'read'} onChange={(e) => handleServiceChange(index, e)} sx={{ height: '40px' }} required>
                            <MenuItem key={'read'} value={'read'}>Read</MenuItem>
                            <MenuItem key={'write'} value={'write'}>Write</MenuItem>
                        </Select>
                    ),
                }
            );
            return Object.assign({}, ...fields);
        });
    };
    const tableThresholdData = {
        columns: [
            { Header: "Contact ID", accessor: "contact_id" },
            { Header: "First Name", accessor: "first_name" },
            { Header: "Last Name", accessor: "last_name" },
            { Header: "Type", accessor: "type" },
            { Header: "Access Type", accessor: "access_type" },
            { Header: "Service Access Type", accessor: "service_access_type" },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            {(
                                <Tooltip title="Delete Parameter">
                                    <IconButton onClick={() => removeList(info.cell.row.index)}>
                                        <MDTypography><DeleteIcon /></MDTypography>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </MDBox>
                    );
                },
            }
        ],
        rows: getRows(),
    };

    return (
        <Card style={{ marginTop: '1rem' }}>
            <MDBox display="flex" flexDirection="column" px={3} my={2}>
                <ContactDeviceAccessTableView contacts={contactsList} selectedContacts={selectedThreRows} setSelectedContacts={setSelectedThreRows} />
                <DataTable table={tableThresholdData} canSearch={true} tableHeight="calc(100vh - 410px)" />
            </MDBox>
        </Card>
    )
}

export default ContactDeviceAccess;